// Convert any YouTube URL (watch, youtu.be, shorts, playlist, embed) to a normalised set of refs
// Returns { videoId, listId, watchUrl, thumbUrl, embedUrl } or null
export function parseYoutubeUrl(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    let videoId = null;
    let listId = null;
    if (u.hostname.includes("youtu.be")) {
      videoId = u.pathname.slice(1).split("/")[0];
      listId = u.searchParams.get("list");
    } else if (u.hostname.includes("youtube.com")) {
      if (u.pathname === "/watch") { videoId = u.searchParams.get("v"); listId = u.searchParams.get("list"); }
      else if (u.pathname.startsWith("/shorts/")) videoId = u.pathname.split("/")[2];
      else if (u.pathname.startsWith("/embed/")) { videoId = u.pathname.split("/")[2]; listId = u.searchParams.get("list"); }
      else if (u.pathname === "/playlist") { listId = u.searchParams.get("list"); }
    }
    if (!videoId && !listId) return null;
    const watchUrl = videoId
      ? `https://www.youtube.com/watch?v=${videoId}${listId ? `&list=${listId}` : ""}`
      : `https://www.youtube.com/playlist?list=${listId}`;
    let thumbUrl = null;
    if (videoId) thumbUrl = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
    else if (listId) thumbUrl = `https://i.ytimg.com/vi/dummy/maxresdefault.jpg`;
    const params = new URLSearchParams({ rel: "0", modestbranding: "1", autoplay: "1" });
    if (listId) params.set("list", listId);
    const embedUrl = videoId
      ? `https://www.youtube.com/embed/${videoId}?${params.toString()}`
      : `https://www.youtube.com/embed/videoseries?list=${listId}&rel=0&modestbranding=1&autoplay=1`;
    return { videoId, listId, watchUrl, thumbUrl, embedUrl };
  } catch {
    return null;
  }
}

// Backwards-compat helper
export function youtubeEmbedUrl(url) {
  return parseYoutubeUrl(url)?.embedUrl ?? null;
}
